import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

/**
 * #sanity
 * Client for mutations
 */
export const SClient = sanityClient({ 
  projectId: process.env.NEXT_PUBLIC_PROJECT_ID, 
  dataset: 'production',
  apiVersion: '2022-03-10',
  useCdn: false,
  //token: process.env.NEXT_PUBLIC_SANITY_TOKEN
});

const builder = imageUrlBuilder(SClient);
/**
 * #sanity
 * Pictures and file url
 */

export const urlFor = (source) => builder.image(source);
export const fileUrl = (source) => source.asset.url;

//export const urlForFile = (source) => builder.flipVertical(source);

// export url:

/*
https://<projectId>.api.sanity.io/v2021-06-07/data/export/<dataset>/
https://2natup74.api.sanity.io/v2022-03-10/data/export/production/

sanity dataset export &lt; production&gt; . --types sanity.imageAsset

*/ 